var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42991 22.53C3.54419 23.8552 4.61078 24.8702 5.88961 24.8759H14.3897C15.674 24.8702 16.7352 23.8495 16.8494 22.53L18.1664 7.7048H2.10754L3.42447 22.53H3.42991ZM11.7831 11.968C11.7831 11.4943 12.1532 11.1165 12.6048 11.1165C13.0565 11.1165 13.4265 11.4999 13.4265 11.968V19.7556C13.4265 20.2292 13.0565 20.6071 12.6048 20.6071C12.1532 20.6071 11.7831 20.2236 11.7831 19.7556V11.968ZM6.84737 11.968C6.84737 11.4943 7.21742 11.1165 7.66909 11.1165C8.12076 11.1165 8.4908 11.4999 8.4908 11.968V19.7556C8.4908 20.2292 8.12076 20.6071 7.66909 20.6071C7.21742 20.6071 6.84737 20.2236 6.84737 19.7556V11.968ZM20.022 5.14465C20.022 5.6127 19.652 5.99616 19.2003 5.99616H1.07904C0.621926 5.99616 0.257324 5.6127 0.257324 5.14465C0.257324 4.67661 0.627368 4.29315 1.07904 4.29315H4.68697L5.65017 2.29691C6.06919 1.42285 6.929 0.875854 7.86499 0.875854H12.4089C13.3449 0.875854 14.2047 1.42285 14.6237 2.29127L15.5869 4.28751H19.1949C19.6465 4.28751 20.0166 4.67097 20.0166 5.13901L20.022 5.14465Z",
    className: "color1Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlackIcon);
export default __webpack_public_path__ + "static/media/delete-black-icon.6b808d9503a0ddd642d973c871d35201.svg";
export { ForwardRef as ReactComponent };